import { render } from "./TwoStep.vue?vue&type=template&id=561b9524&scoped=true"
import script from "./TwoStep.vue?vue&type=script&lang=js"
export * from "./TwoStep.vue?vue&type=script&lang=js"

import "./TwoStep.vue?vue&type=style&index=0&id=561b9524&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561b9524"]])

export default __exports__